// The one list of public tools. Home, the header Tools menu and the not-found page all
// read their titles and descriptions from here, so each tool is described one way.
export const TOOLS = Object.freeze([
  Object.freeze({
    to: '/tools/qfwine',
    title: 'Qantas Wine Tracker',
    description: 'Qantas Wine bonus-point deals, ranked by cents per point.',
  }),
  Object.freeze({
    to: '/tools/qfmarketplace',
    title: 'Qantas Marketplace Tracker',
    description: 'Qantas Marketplace bonus-point offers, ranked by cents per point.',
  }),
  Object.freeze({
    to: '/tools/reward-sc-calculator',
    title: 'Status Credit Calculator',
    description: 'Estimate the Status Credits a Classic Reward or paid flight earns.',
  }),
]);
